import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f291a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "msg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cut-line" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "La page à laquelle vous tentez d'accéder n'existe pas ou a été déplacée", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1),
      _hoisted_2
    ]),
    _createElementVNode("section", null, [
      _hoisted_3,
      (_ctx.previousPath != '/')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: this.$store.state.app.previousPath
          }, {
            default: _withCtx(() => [
              _createTextVNode("Retourner à la page précédente")
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: this.$store.state.app.uri.home
          }, {
            default: _withCtx(() => [
              _createTextVNode("Retour à l'accueil")
            ]),
            _: 1
          }, 8, ["to"]))
    ])
  ]))
}